// removed by extract-text-webpack-plugin
module.exports = {"loginArea":"_2AFyqkjlyb0CO1VcnXls6d","logo":"_3rwEk4SqULKfCrSQE_vB","error":"k4-B-NCdHXdrWgkjb87Bz"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Login/style.scss
// module id = 1233
// module chunks = 0